import React from 'react';
import styled from 'styled-components';

const Paragraph = styled.p`
  text-align: left;
  color: ${props => props.theme.secondaryColor};
  margin: 0;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: 12px;
  display: flex;
  justify-content: start;
  ${props => (props.theme.isMobile ? `
    order: 2;
    margin: 8px 0 15px 0;
    flex-direction: column;
  ` : `
    order: 1;
    & > span:nth-child(2) {
      margin-left: 10px;
    }
  `)};
`;

const Copyright = () => (
  <Paragraph>
    <span>
      {`©${new Date().getFullYear()} Livewire Markets Pty Ltd. All rights reserved.`}
    </span>
    <span>
      {`Version ${window.Livewire.version}`}
    </span>
  </Paragraph>
);

export default React.memo(Copyright);
